import { QueryDocumentSnapshot, SnapshotOptions } from "firebase/firestore";

export default class ChoirSongPerformance {
    createdAt: Date;
    createdBy: String;
    date: Date | string; // Support both for compatibility
    number: Number;
    occasion?: String;
    year?: number; // For efficient filtering
    month?: number; // For efficient filtering
    // Tenant id, needed by the collection-group queries of the admin view.
    gemeindeId?: string;
    // Where the performance comes from: "import", "sheet", "synology" or "service:<id>".
    source?: string;

    constructor(createdAt: Date, createdBy: String, date: Date | string, number: Number, occasion?: String, year?: number, month?: number) {
        this.createdAt = createdAt;
        this.createdBy = createdBy;
        this.date = date;
        this.number = number;
        this.occasion = occasion;
        
        // Auto-calculate year and month from date if not provided
        if (!year || !month) {
            const dateObj = typeof date === 'string' ? new Date(date + 'T00:00:00') : date;
            this.year = year ?? dateObj.getFullYear();
            this.month = month ?? (dateObj.getMonth() + 1);
        } else {
            this.year = year;
            this.month = month;
        }
    }
}

export const choirSongPerformanceConverter = {
    toFirestore: (performance: ChoirSongPerformance) => {
        const data: Record<string, unknown> = {
            createdAt: performance.createdAt,
            createdBy: performance.createdBy,
            date: performance.date,
            number: performance.number,
            year: performance.year,
            month: performance.month,
        };
        if (performance.occasion) {
            data.occasion = performance.occasion;
        }
        if (performance.gemeindeId) {
            data.gemeindeId = performance.gemeindeId;
        }
        if (performance.source) {
            data.source = performance.source;
        }
        return data;
    },

    fromFirestore: (snapshot: QueryDocumentSnapshot, options: SnapshotOptions) => {
        const data = snapshot.data(options);
        const performance = new ChoirSongPerformance(
            data.createdAt,
            data.createdBy,
            data.date,
            data.number,
            data.occasion,
            data.year,
            data.month
        );
        performance.gemeindeId = data.gemeindeId;
        performance.source = data.source;
        return performance;
    },
};
